import { ImageErrorType, SCError } from "@next-platform/packages-ts-types";
import { useTranslation } from "../localization/hooks";
const { ERROR_CODE_PREFIX } = SCError || {};
// eslint-disable-next-line id-length -- matches useTranslation().t; literal t("error:image.…") keys for grep / i18n extractors
function getNonContextImageErrors(t) {
    return {
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.FILE_SIZE_TOO_LARGE}`]: t("error:image.fileSizeTooLarge"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.GENERATED_IMAGE_NOT_ALLOWED}`]: t("error:image.generatedImageNotAllowed"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.IMAGE_GENERATION_ERROR}`]: t("error:image.imageGenerationError"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.IMAGE_PROMPT_GENERATION_ERROR}`]: t("error:image.imagePromptGenerationError"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.IMAGE_REFERENCE_NOT_FOUND}`]: t("error:image.imageReferenceNotFound"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.IMAGE_TYPE_NOT_SUPPORTED}`]: t("error:image.imageTypeNotSupported"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.IMAGE_VIOLATE_CONTENT_GUIDELINES}`]: t("error:image.imageViolateContentGuidelines"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.INVALID_IMAGE_PATH}`]: t("error:image.invalidImagePath"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.NOT_ALLOWED_TO_GENERATE_IMAGES}`]: t("error:image.notAllowedToGenerateImages"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.NOT_ALLOWED_TO_SAVE_IMAGES}`]: t("error:image.notAllowedToSaveImages"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.NSFW_CONTENT_NOT_ALLOWED}`]: t("error:image.nsfwContentNotAllowed"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.NSFW_PUBLIC_FIGURE_NOT_ALLOWED}`]: t("error:image.nsfwPublicFigureNotAllowed"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.SIGHT_ENGINE_MODERATION_ERROR}`]: t("error:image.sightEngineModerationError"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.UNDER_AGE_CONTENT_NOT_ALLOWED}`]: t("error:image.underAgeContentNotAllowed"),
        [`${ERROR_CODE_PREFIX}-${ImageErrorType.UPLOAD_FAILED}`]: t("error:image.uploadFailed"),
    };
}
// eslint-disable-next-line import/prefer-default-export -- named hook export matches package barrel
export function useImageErrors() {
    const { t } = useTranslation();
    const nonContextImageErrors = getNonContextImageErrors(t);
    const getMessage = ({ errorCode, fallbackMessage, skipDefaultMessage }) => {
        const nonContextError = nonContextImageErrors[errorCode];
        if (nonContextError) {
            return nonContextError;
        }
        if (skipDefaultMessage)
            return "";
        return fallbackMessage || t("error:fallbackError");
    };
    return {
        getMessage,
    };
}
